import { ItemAvailabilityChangeContract } from 'interfaces'
import { PrinterContract, TableGroupContract } from 'models'
import { Subject } from 'rxjs'

export enum POSEventType {
    OnReserveTable,
    OnReleaseTable,
    OnReleaseTableGroup,
    OnJoinTables,
    OnSplitTables,
    OnItemAvailabilityChanged,
    OnPrinterSettingChanged,
    OnPrinterSettingRemoved,
    OnPOSHubReconnected,
    OnCompleteSentPrinterStatusToCloudAPI,
    OnBilledTable,
    OnTableLayoutChanged,
}

export type POSEventArg =
    | {
          type: POSEventType.OnReserveTable
          /** opened table ID */
          params: string
      }
    | {
          type: POSEventType.OnReleaseTable
          /** released table ID */
          params: string
      }
    | {
          type: POSEventType.OnReleaseTableGroup
          /** released table group ID */
          params: string
      }
    | {
          type: POSEventType.OnJoinTables
          params: {
              joinedTableIds: string[]
              tableGroup: TableGroupContract
          }
      }
    | {
          type: POSEventType.OnSplitTables
          params: {
              ungroupedTableIds: string[]
              tableGroupId: string
          }
      }
    | {
          type: POSEventType.OnItemAvailabilityChanged
          params: ItemAvailabilityChangeContract[]
      }
    | {
          type: POSEventType.OnPrinterSettingChanged
          params: PrinterContract
      }
    | {
          type: POSEventType.OnPrinterSettingRemoved
          /** removed printer IDs */
          params: string[]
      }
    | {
          type: POSEventType.OnPOSHubReconnected
      }
    | {
          type: POSEventType.OnCompleteSentPrinterStatusToCloudAPI
      }
    | {
          type: POSEventType.OnTableLayoutChanged
      }
    | {
          type: POSEventType.OnBilledTable
          params: string
      }

const posEvent = new Subject<POSEventArg>()

export default posEvent
